module.exports = __webpack_public_path__ + "img/404.05bd9eee.png";